import type { NDateLocale } from './enUS'
import { kn } from 'date-fns/locale'

const dateKnIN: NDateLocale = {
  name: 'kn-IN',
  locale: kn
}

export default dateKnIN
